import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['tab', 'tabPanel']

  initialize() {
    this.showTab();
  }

  change(e) {
    this.index = this.tabTargets.indexOf(e.target);
    this.showTab(this.index);
  }

  showTab() {
    this.tabPanelTargets.forEach((el, i) => {
      if (i === this.index) {
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });

    this.tabTargets.forEach((el, i) => {
      if (i === this.index) {
        el.classList.remove('text-gray-500');
        el.classList.remove('bg-white-200');
        el.classList.add('text-blue-700');
        el.classList.add('bg-blue-100');
      } else {
        el.classList.remove('text-blue-700');
        el.classList.remove('bg-blue-100');
        el.classList.add('text-gray-500');
        el.classList.add('bg-white');
      }
    });
  }

  get index() {
    return parseInt(this.data.get('index'), 10);
  }

  set index(value) {
    this.data.set('index', value);
    this.showTab();
  }
}
